module.exports = __webpack_public_path__ + "img/img20.241a82f6.png";